/**
 * Legacy parity: EMAIL_TEMPLATE_VALIDATION not-empty-html (Yup) in validations.ts
 */
export function isNonemptyHtml(value: unknown): boolean {
  if (value == null) return false;
  const str = String(value);
  const cleaned = str
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
  return cleaned.length > 0;
}
